import { auth } from '../../../auth/clientAppAuth';
import { createPublicClient } from '../../../api/companyRecords';

/**
 * Ensures a company client document exists for storefront checkout metadata.
 * Mirrors guest / signed-in behavior used when creating unpaid storefront appointments.
 */
export async function ensureStorefrontClientForPayment({
  companyId,
  customerInfo,
  isSignedInClient,
  storefrontClient,
}) {
  if (!companyId) {
    throw new Error('Company is missing.');
  }

  if (isSignedInClient) {
    const sessionUser = auth.currentUser;
    if (!sessionUser) {
      throw new Error('Your session expired. Please sign in again to complete payment.');
    }
    const clientId = storefrontClient?.id || sessionUser.uid;
    return {
      clientId,
      clientName: customerInfo.name || storefrontClient?.name || '',
      clientEmail: sessionUser.email || storefrontClient?.email || customerInfo.email || '',
      clientPhone: customerInfo.phone || storefrontClient?.phone || '',
    };
  }

  const trimmedName = (customerInfo.name || '').trim();
  if (!trimmedName || !customerInfo.email?.trim()) {
    throw new Error('Name and email are required before payment.');
  }

  const [firstName, ...rest] = trimmedName.split(/\s+/);
  const lastName = rest.join(' ');

  const customerData = {
    firstName,
    lastName,
    name: trimmedName,
    searchName: trimmedName.toLowerCase(),
    email: customerInfo.email.trim(),
    phone: customerInfo.phone || '',
    source: 'storefront',
    status: 'active',
    archived: false,
    createdAt: new Date().toISOString(),
    loyaltyPoints: 0,
    totalSpent: 0,
    appointmentCount: 0,
  };

  const customerDoc = await createPublicClient({ companyId, record: customerData });
  return {
    clientId: customerDoc.id,
    clientName: trimmedName,
    clientEmail: customerInfo.email.trim(),
    clientPhone: customerInfo.phone || '',
  };
}
